<template>
  <div class="page-box">
    <!-- 头部组件 -->
    <ProductHeader :currentTab="2.3" stepTitle="房型/价格计划"></ProductHeader>
    <div class="page-main">
      <!-- 发布助手 -->
      <PublishHelper></PublishHelper>
      <div class="main-content">
        <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'0px'}">
          <a-row slot="title">
            <a-col :span="8">
              <span class="card-title">价格计划</span>
              <span class="card-txt">房型名称：{{ optionName }}</span>
            </a-col>
          </a-row>
          <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules"
                        :label-col="currentFormLayout.labelCol" :wrapper-col="currentFormLayout.wrapperCol"
          >
            <a-form-model-item label="计划名称" prop="ratePlanName">
              <a-input v-model="ruleForm.ratePlanName" :maxLength="100" style="max-width:700px;" placeholder="请输入">
                <span slot="addonAfter">{{ ruleForm.ratePlanName.length }}/100</span>
              </a-input>
            </a-form-model-item>
            <a-form-model-item label="床型">
              <!-- <a-select
                v-model="hotelBindBeds"
                mode="multiple"
                placeholder="请选择"
                option-label-prop="label"
                style="max-width:700px;"
                @change="handleTypeChange"
              >
                <a-select-option v-for="item in bedTypeList" :key="item.value" :value="item.value" :label="item.key">
                  <span role="img" :aria-label="item.key">{{item.key}}</span>
                </a-select-option>
              </a-select> -->
              <a-input v-model="ruleForm.ratePlanBedType" style="max-width:700px;" :maxLength="50"
                       placeholder="请输入"></a-input>
            </a-form-model-item>
            <a-form-model-item label="床宽" prop="ratePlanBedWidth">
              <a-input v-model="ruleForm.ratePlanBedWidth" style="max-width:700px;" :maxLength="50"
                       placeholder="请输入"></a-input>
            </a-form-model-item>
            <a-form-model-item label="最大入住人数" prop="ratePlanCheckInMax">
              <a-input-number v-model="ruleForm.ratePlanCheckInMax" placeholder="请输入" :min="1" :max="99"/>
            </a-form-model-item>
            <a-form-model-item label="房间面积">
              <a-input v-model="ruleForm.ratePlanBedArea" style="max-width:700px;" :maxLength="15"
                       placeholder="请输入"></a-input>
            </a-form-model-item>
            <a-form-model-item label="楼层">
              <a-input v-model="ruleForm.ratePlanFloor" style="max-width:700px;" :maxLength="10"
                       placeholder="请输入"></a-input>
            </a-form-model-item>


            <a-form-model-item label="早餐数量" style="margin-bottom: 0;" :required="true">
              <a-form-model-item label="" prop="ratePlanBreakfastNum" style="margin-bottom: 0;display: inline-block">
                <a-input-number v-model.number="ruleForm.ratePlanBreakfastNum" placeholder="请输入" :min="0" :max="99"/>
              </a-form-model-item>
              <!--              <span>&nbsp;&nbsp;其他&nbsp;&nbsp;</span>-->
              <a-form-model-item label="其他" prop="ratePlanBreakfastCount"
                                 style="margin-bottom: 0;display: inline-block;min-width: 500px;margin-left: 20px">
                <a-input v-model="ruleForm.ratePlanBreakfastCount" :maxLength="50"
                         placeholder="请输入" style="max-width: 400px;"></a-input>
              </a-form-model-item>
            </a-form-model-item>
            <a-form-model-item label="宽带">
              <a-radio-group v-model="ruleForm.ratePlanBroadband">
                <a-radio :value="1">无宽带</a-radio>
                <a-radio :value="2">免费宽带</a-radio>
                <a-radio :value="3">收费宽带</a-radio>
                <a-radio :value="4">部分收费宽带</a-radio>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="窗户">
              <a-radio-group v-model="ruleForm.ratePlanWindow">
                <a-radio :value="1">无</a-radio>
                <a-radio :value="2">有窗</a-radio>
                <a-radio :value="3">部分有窗</a-radio>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="取消政策" prop="ratePlanCancel">
              <a-radio-group v-model="ruleForm.ratePlanCancel" @change="onCancelChange">
                <a-radio :value="1">不可取消</a-radio>
                <a-radio :value="2">限时免费取消</a-radio>
                <a-radio :value="3">随时取消</a-radio>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item v-if="ruleForm.ratePlanCancel==2" :wrapper-col="currentFormLayout.offsetCol">
              <a-form-model-item style="display:inline-block;" prop="ratePlanCancelDay">
                <span>提前</span>
                <a-input-number v-model="ruleForm.ratePlanCancelDay" placeholder="请输入" :min="1" :max="10"/>
                <span>天</span>
              </a-form-model-item>
              <a-form-model-item style="display:inline-block;">
                <a-time-picker :allowClear="false" v-model="cancelTime" @change="onChangeCancelTime" format="HH:mm"/>
              </a-form-model-item>
              <a-textarea v-model="ruleForm.ratePlanRemark" :maxLength="200" placeholder="请输入备注"
                          :auto-size="{ minRows: 2, maxRows: 4 }"/>
            </a-form-model-item>
            <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
              <a-button type="primary" :disabled="proSource!=0" @click="onSubmit" :loading="submitLoading">提交
              </a-button>
              <!-- <a-button  @click="backEvent" style="margin-left: 10px">保存草稿</a-button> -->
            </a-form-model-item>
          </a-form-model>
        </a-card>
      </div>
    </div>
  </div>
</template>

<script>
import ProductHeader from '../components/ProductHeader'
import PublishHelper from '../components/PublishHelper'
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'
import moment from 'moment'

export default {
  name: 'HotelPlanInfo',
  components: {
    ProductHeader,
    PublishHelper
  },
  mixins: [ruleFormMixins],
  data() {
    return {
      moment,
      proSource: this.$route.query.proSource, //判断自有产品还是非自有产品
      proId: this.$route.query.proId, //产品ID
      catalogId: this.$route.query.catalogId,
      optionId: this.$route.query.optionId,
      ratePlanId: this.$route.query.ratePlanId,
      optionName: this.$route.query.optionName,
      ruleForm: {
        ratePlanBedArea: '',//房型面积
        ratePlanBedType: '',//床型
        ratePlanBedWidth: '',//床宽
        ratePlanBreakfastCount: '',//早餐数量
        ratePlanBroadband: 2,//1为无宽带，2为免费，3为收费，4为部分收费
        ratePlanCancel: 1,// 1为不可取消，2为限时免费取消,3为随时取消
        ratePlanCancelDay: '',//限时取消天数
        ratePlanCancelTime: '',// 限时取消时间
        ratePlanCheckInMax: 2,//最大入住数
        ratePlanFloor: '',//楼层
        ratePlanBreakfastNum: '',
        ratePlanId: this.$route.query.ratePlanId,// 价格计划ID
        ratePlanName: '',//价格计划名称
        ratePlanOptionId: this.$route.query.optionId,//房型Id
        ratePlanProId: this.$route.query.proId,//主产品Id
        ratePlanRemark: '',//备注
        ratePlanWindow: 2// 1为无窗，2为有窗，3为部分有窗
      },
      cancelTime: undefined,//提交删除
      bedTypeList: [],
      hotelBindBeds: [],
      submitLoading: false,
      submitFormData: '',
      rules: {
        ratePlanName: [
          { required: true, message: '请输入价格计划名称', trigger: 'blur' }
        ],
        ratePlanCheckInMax: [
          { pattern: /^[1-9][0-9]?$/, message: '请输入正确的入住人数', trigger: 'blur' }
        ],
        ratePlanBreakfastNum: [
          { required: true, message: '请输入早餐数量', trigger: 'blur' },
          { pattern: /^([0]|[1-9][0-9]*)$/, message: '早餐数量有误', trigger: 'blur' }
        ],
        ratePlanCancel: [
          { required: true, message: '请选择取消政策', trigger: 'change' }
        ],
        ratePlanCancelDay: [
          { required: true, message: '请输入提前天数', trigger: 'blur' }
        ],
        ratePlanBreakfastCount: [
          { validator: this.validatorRatePlanBreakfastCount }
        ]
      }
    }
  },
  mounted() {
    this.getPlanInfo()
    this.getBedTypeList()
  },
  methods: {
    validatorRatePlanBreakfastCount(rule, value, callback) {
      if (/[^\d]/g.test(value)) {
        callback('早餐备注只能输入数字')
      } else {
        callback()
      }
    },
    onCancelChange(e) {
      this.getLogUtils().logWithTag('onCancelChange', e.target.value)
      this.ruleForm.ratePlanCancel = e.target.value
    },
    onChangeCancelTime(time, timeStr) {
      this.getLogUtils().logWithTag('onChangeCancelTime', timeStr)
      this.cancelTime = time
      this.ruleForm.ratePlanCancelTime = timeStr
    },
    handleTypeChange(value) {
      this.getLogUtils().logWithTag('handleTypeChange', value)
      if (value && value.length > 0) {
        this.ruleForm.ratePlanBedType = value.join(',')
      } else {
        this.ruleForm.ratePlanBedType = ''
      }
      this.getLogUtils().logWithTag('handleTypeChange', this.ruleForm.ratePlanBedType)
    },
    checkForm() {
      if (this.ruleForm.ratePlanCancel == 2) {
        if (!this.cancelTime) {
          this.$message.error('请选择提前时间')
          return false
        }
      }
      return true
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.checkForm()) {
            this.submitData()
          }
        } else {
          this.getLogUtils().logWithTag('error submit!!', '错误')
          return false
        }
      })
    },
    // 保存接口
    submitData() {
      this.submitLoading = true
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      this.getLogUtils().logWithTag('submitData', this.submitFormData)
      this.getHttpServices().getProService().post('product/hotel/editRatePlan', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('酒店价格计划保存成功')
        this.ruleForm.ratePlanId = res
        this.$router.push({
          name: 'HotelOptionList',
          query: {
            proId: this.proId,
            optionId: this.optionId,
            catalogId: this.catalogId,
            proSource: this.proSource
          }
        })
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    //获取酒店房型
    getBedTypeList() {
      this.getHttpServices().getProService().get('product/hotel/getBedTypeList').then(res => {
        this.getLogUtils().logWithTag('getBedTypeList', res)
        this.bedTypeList = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 获取酒店价格计划信息
    getPlanInfo() {
      if (this.ratePlanId != 0) {
        this.getHttpServices().getProService().post('product/hotel/getRatePlan', {
          optionId: this.optionId,
          ratePlanId: this.ratePlanId
        }).then(res => {
          this.getLogUtils().logWithTag('getOptioInfo', res)
          this.ruleForm = res
          this.cancelTime = res.ratePlanCancelTime ? moment(res.ratePlanCancelTime, 'HH:mm') : undefined
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      }
    }
  }

}
</script>
<style lang="less" scoped>
.page-box {
  .page-main {
    margin: 10px;
    display: flex;

    .main-content {
      margin-left: 10px;
      width: 400px;
      flex-grow: 1;
    }
  }
}

.pt10 {
  padding-top: 10px;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

.card-txt {
  font-size: 12px;
}

/* you can make up upload button and sample style by using stylesheets */
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>